import { Component, ViewChild, ElementRef, Renderer, AfterViewInit } from '@angular/core';
import { ToastOptions, ToastyService, ToastyConfig } from "ng2-toasty";
import { AppConstants } from "../../app.constant";
import { ToolbarEvent } from "../../core/events/toolbar.event";

@Component({
    selector: 'ixs-loader',
    templateUrl: 'ixsloader.component.html',
    styles: ['ixsloader.css']
})
export class IxsloaderComponent implements AfterViewInit {
    toolbarSubscription: any;
    toolbarEvent: any;
    ngAfterViewInit(): void {
        if (this.element && this.element.nativeElement)
            this.element.nativeElement.children[0].children[0].style.display = "none";
    }

    constructor(private toastyService: ToastyService, private element: ElementRef) {

        this.toolbarEvent = AppConstants.injector.get(ToolbarEvent);

        this.toolbarSubscription = this.toolbarEvent.click().subscribe(async arg => {
            switch (arg.key) {
                case ('start'):
                    await this.startLoading();
                        break;

            }

            switch (arg.key) {
                case ('stop'):
                    await this.stopLoading();
                        break;

            }

        });

    }



    startLoading() {
        this.element.nativeElement.children[0].children[0].style.display = "block";
        var toastOptions: ToastOptions = {
            title: '',
            msg: "<div class='loaderBox'><center><img  src='assets/img/fav.ico' style='margin-top: 35px;width: 45px;'></center><div class='circle-loader ixsloader'><div></div> <div></div> <div></div> <div></div>    <div></div>    <div></div>    <div></div>    <div></div></div><div class='wait' style='margin-top: 18px;'>Please Wait...</div><div id='overlayDiv'></div></div> ",
            showClose: false,
            theme: 'bootstrap',
            timeout: 0,

        }
        

        this.toastyService.default(toastOptions);
    }

    stopLoading() {
        this.toastyService.clearAll();
        this.element.nativeElement.children[0].children[0].style.display = "none";
    }



}



// WEBPACK FOOTER //
// ./src/app/components/ixsloader/ixsloader.component.ts